import {
  CardContent,
  CardFooter,
  CardHeader,
  Typography,
  CardTitle,
  DataTable,
  Loading,
  Button,
  Card,
} from '@ui/components';
import { CostCenterAccountDetails } from '@pages/cost-centers/containers/cost-center-account-details/cost-center-account-details';
import { ComponentPropsWithoutRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Wallet } from '@ui/components/icons';
import { cn } from '@ui/utils';

import {
  useCostCenterTopUpsHistory,
  TopUpsHistoryFilters,
} from './use-cost-center-top-ups-history';

export const CostCenterTopUpsHistory: FC<
  ComponentPropsWithoutRef<typeof Card> & { filters: TopUpsHistoryFilters }
> = ({ className, filters, ...props }) => {
  const { t } = useTranslation();
  const { table, isLoading, columnsLength, costCenterId, itemsLength } =
    useCostCenterTopUpsHistory(filters);

  return (
    <Card className={cn('flex flex-col', className)} {...props}>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Wallet className="w-4.5 h-4.5 text-weak" />
          <CardTitle>{t('COST_CENTER.TOP_UPS_HISTORY.TITLE')}</CardTitle>
        </div>
      </CardHeader>

      <CardContent className="flex-1 overflow-auto">
        <Loading isLoading={isLoading} className="h-full">
          {itemsLength > 0 ? (
            <DataTable
              noResultsComponent={
                <Typography variant="labelMediumMedium">
                  {t('COST_CENTER.TOP_UPS_HISTORY.EMPTY')}
                </Typography>
              }
              className="[&_tr:last-child]:border-b [&_tr:last-child]:border-border-weak"
              columnsLength={columnsLength}
              isLoading={isLoading}
              table={table}
              hideHeader
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <Typography variant="labelMediumMedium">
                {t('COST_CENTER.TOP_UPS_HISTORY.EMPTY')}
              </Typography>
            </div>
          )}
        </Loading>
      </CardContent>

      {!!costCenterId && (
        <CardFooter>
          <CostCenterAccountDetails costCenterId={costCenterId}>
            <Button disabled={isLoading} variant="link" wide>
              {t('COST_CENTER.TOP_UPS_HISTORY.VIEW_ALL')}
            </Button>
          </CostCenterAccountDetails>
        </CardFooter>
      )}
    </Card>
  );
};
